export default __webpack_public_path__ + "static/media/Snd4.b65d2aa7.mp3";